import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-500/30 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full bg-accent-500/80 text-background-50 text-xs font-medium whitespace-nowrap">
            {article.categoryName}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-semibold font-heading text-foreground-950 group-hover:text-accent-500 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
          <span className="text-accent-500 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
            阅读全文 <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}